<template>
  <div class="navbar__profile-nav">
    <el-dropdown class="r-dropdown" trigger="click" @command="handleClick">
      <el-button class="r-dropdown__button">
        <div class="r-dropdown__button-row">
          <r-text type="caption">
            {{ $t("current-profile") }}
          </r-text>
        </div>
        <div class="r-dropdown__button-row">
          <r-text v-if="this.currentProfile.name">
            {{ currentProfile.name }}
          </r-text>
          <r-text v-else>
            {{ $t("profiles:menu-title") }}
          </r-text>
          <i class="el-icon-arrow-down el-icon--right"></i>
        </div>
      </el-button>
      <el-dropdown-menu slot="dropdown" class="r-dropdown-menu profiles-menu">
        <el-dropdown-item
          v-for="item in profilesList"
          :key="item.id"
          :command="item.id"
          :class="currentProfile.id === item.id ? 'active' : ''"
        >
          <div class="r-dropdown-menu__item-wrapper">
            <r-text>{{ item.name }}</r-text>
          </div>
        </el-dropdown-item>
        <div class="devider" />
        <el-dropdown-item command="open-settings">
          <div class="r-dropdown-menu__item-wrapper">
            <r-title type="subtitle-1">
              {{ $t("profiles:menu-settings") }}
            </r-title>
          </div>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import variables from "@/styles/variables.scss";

export default {
  data() {
    return {
      userId: this.$store.state.userId,
      primaryColor: variables.primaryColor
    };
  },
  computed: {
    profilesList() {
      return this.$store.state.profiles.profilesTree || [];
    },
    currentProfile() {
      return this.$store.state.profiles.currentProfile || {};
    }
  },
  methods: {
    handleClick(val) {
      switch (val) {
        case "open-settings":
          this.openProfilesSettings();
          break;
        default:
          this.changeProfile(val);
          break;
      }
    },
    openProfilesSettings() {
      this.$store.commit("OPEN_MODAL_WINDOW", "profiles");
    },
    async changeProfile(id) {
      if (id === this.currentProfile.id) return;
      const dataUserObj = {
        id: this.userId,
        current_profile_id: id
      };
      try {
        this.$store.commit("CHANGE_PROFILE", true);
        await this.$store.dispatch("PUT_REQUEST", {
          url: `user`,
          data: dataUserObj
        });
        document.location.reload(true);
      } catch (e) {
        this.$store.commit("CHANGE_PROFILE", false);
      }
    }
  }
};
</script>

<style lang="scss">
.navbar__profile-nav {
  width: calc(100% - 60px);
  overflow: hidden;
  margin-top: -4px;
  .r-dropdown__button {
    overflow: hidden;
    line-height: 20px;
    padding: 0 8px 0;
    span {
      flex-direction: column;
      align-items: flex-start;
      .r-dropdown__button-row {
        display: flex;
        align-items: center;
      }
    }
  }
  .r-text {
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .r-dropdown,
  .r-dropdown__button {
    height: 100%;
    width: 100%;
  }
}
.profiles-menu {
  max-width: 250px;
  width: 206px;
  left: 52px !important;
  top: 45px !important;
}
</style>

<i18n>
{
  "ru": {
    "current-profile": "Текущий профиль",
    "profiles:menu-title": "Меню профилей",
    "profiles:menu-settings": "Настройки профилей"
  },
  "en": {
    "current-profile": "Current profile",
    "profiles:menu-title": "Profiles menu",
    "profiles:menu-settings": "Profiles settings"
  }
}
</i18n>
